import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { useUserQuestions } from '../../../../../../data/hooks/questions/useUserQuestions';
import { useMyUserId } from '../../../../../../data/hooks/sessionHooks';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';

function StepPostQuest(props) {
    const { eventId } = props,
        i18n = useI18n(),
        selfId = useMyUserId(),
        questions = useUserQuestions(eventId, selfId);

    return (
        <StartNetworkingStep href={['/events', eventId, 'qa', 'all', 'create'].join('/')} complete={questions.length > 0}>
            {i18n['start.post_quests']}
        </StartNetworkingStep>
    );
}

export default StepPostQuest;
